// extracted by mini-css-extract-plugin
export default {"navlinks-container":"LibraryActions_navlinks-container__o8tuZ","navlink":"LibraryActions_navlink__SufPg","navlink--selected":"LibraryActions_navlink--selected__TeCr6"};